import axios from 'axios';
import { getCookie, setCookie, removeCookie } from '@util/cookie';
import { setGrayItem, removeGrayItem, checkGrayItem } from '@util/handleGrayByLocalstorage';
import { grayList } from "../../constants/gray";

let grayItems = getGrayObj(grayList);

export const setGrayItems = function (requestid, reload) {
  if (!grayItems || !requestid) {
    return;
  }
  const testKey = Object.keys(grayItems.cookies).concat(Object.keys(grayItems.lsItems)).join(",");
  getGrey(requestid, testKey).then(res => {
    if (res && res.code === 200) {
      let shouldReload = false;
      delete res.code;
      delete res.msg;
      Object.keys(res).forEach(item => {
        if (grayItems.cookies[item]) {
          shouldReload = verifyGrayItem(grayItems.cookies[item], res[item]) || shouldReload;
        } else if (grayItems.lsItems[item]) {
          shouldReload = verifyGrayItem(grayItems.lsItems[item], res[item]) || shouldReload;
        }
      });
      if (shouldReload === true && !reload) {
        window.location.reload();
      }
    }
  });
};
function getGrayObj (grayList) {
  let cookies = {};
  let lsItems = {};
  grayList.forEach(item => {
    if (typeof item === 'string') {
      cookies[item] = {
        name: item,
        value: 'Y',
        location: 'cookie',
        forceReload: true
      };
    } else {
      lsItems[item.testKey] = {
        name: item.name || item.testKey,
        value: item.value || 'Y',
        location: item.location || 'localstorage',
        forceReload: item.forceReload || false,
        otherName: item.otherName || null,
      };
    }
  });
  return {
    cookies: cookies,
    lsItems: lsItems
  };
}

function getGrey (requestid, testKeys) {
  return axios.get(`/erpabtest-api-v2/batch/getTreatmentFe?ip=${requestid}&testKeys=${testKeys}`);
}
function verifyGrayItem (grayItem, res) {
  const { name, value, otherName} = grayItem;
  if (!name) {
    return false;
  }
  let shouldReload = false;
  const getValue = grayItem.location === 'cookie' ? getCookie : checkGrayItem;
  const setValue = grayItem.location === 'cookie' ? setCookie : setGrayItem;
  const removeValue = grayItem.location === 'cookie' ? removeCookie : removeGrayItem;
  if (res.strategy) {
    if (grayItem.location === 'cookie' && getValue(name) !== value) {
      setValue(name, value);
      if (otherName) {
        otherName.forEach(item => {
          setValue(item, value);
        });
      }
      shouldReload = true;
    } else if (grayItem.location !== 'cookie' && !getValue(name, value)) {
      setValue(name, value);
      if (otherName) {
        otherName.forEach(item => {
          setValue(item, value);
        });
      }
      shouldReload = true;
    }
  } else {
    if (getValue(name)) {
      removeValue(name);
      if (otherName) {
        otherName.forEach(item => {
          removeValue(item);
        });
      }
      shouldReload = true;
    }
  }
  return shouldReload && grayItem.forceReload;
}



// WEBPACK FOOTER //
// ./src/components/util/setGray.js